import ApiService from "@/core/services/api.service";

// action types
export const FETCH_BANNERS = "fetchBanners";
export const FETCH_BANNER = "fetchBanner";

// mutation types
export const SET_BANNERS = "setBanners";
export const SET_BANNERS_PAGINATION = "setBannersPagination";
export const SET_BANNER = "setBanner";

const state = {
  banners: [],
  bannersPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  banner: {}
};

const getters = {
  banners(state) {
    return state.banners;
  },
  bannersPagination(state) {
    return state.bannersPagination;
  },
  banner(state) {
    return state.banner;
  }
};

const actions = {
  [FETCH_BANNERS](context) {
    let params = {
      page: context.state.bannersPagination.currentPage
    };

    return new Promise((resolve, reject) => {
      ApiService.query("banners", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_BANNERS, data.data);
          context.commit(SET_BANNERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_BANNER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("banners", id)
        .then(({ data }) => {
          context.commit(SET_BANNER, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_BANNERS](state, banners) {
    state.banners = banners;
  },
  [SET_BANNERS_PAGINATION](state, data) {
    state.bannersPagination = data;
  },
  [SET_BANNER](state, banner) {
    state.banner = banner;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
